var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10671 7.24732C6.04004 7.24065 5.96004 7.24065 5.88671 7.24732C4.30004 7.19398 3.04004 5.89398 3.04004 4.29398C3.04004 2.66065 4.36004 1.33398 6.00004 1.33398C7.63337 1.33398 8.96004 2.66065 8.96004 4.29398C8.95337 5.89398 7.69337 7.19398 6.10671 7.24732Z",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9399 2.66602C12.2333 2.66602 13.2733 3.71268 13.2733 4.99935C13.2733 6.25935 12.2733 7.28602 11.0266 7.33268C10.9733 7.32602 10.9133 7.32602 10.8533 7.33268",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77323 9.70602C1.1599 10.786 1.1599 12.546 2.77323 13.6193C4.60657 14.846 7.61323 14.846 9.44657 13.6193C11.0599 12.5393 11.0599 10.7793 9.44657 9.70602C7.6199 8.48602 4.61323 8.48602 2.77323 9.70602Z",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 13.334C12.7066 13.234 13.1599 13.0407 13.5332 12.754C14.5732 11.974 14.5732 10.6873 13.5332 9.90732C13.1666 9.62732 12.7199 9.44065 12.2466 9.33398",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.b9869f111597cafbcf8bab1bef7610e6.svg";
export { ForwardRef as ReactComponent };